import { render, staticRenderFns } from "./basindic.vue?vue&type=template&id=3e7660aa&scoped=true&"
import script from "./basindic.vue?vue&type=script&lang=js&"
export * from "./basindic.vue?vue&type=script&lang=js&"
import style0 from "./basindic.vue?vue&type=style&index=0&id=3e7660aa&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e7660aa",
  null
  
)

export default component.exports